export var COOKIE_TEST = 'cookieTest-';
export var THIRD_PARTY_CHECK = 'thirdPartyTest=1';
export var CEXP_PROVIDER_LOADED = 'cexp-provider-loaded';
export var CEXP_LOADED = 'cexp-loaded';
export var COOKIE_TEST_QUERY_PARAM = 'cexp-sdk-cookie-test';